import React, { useState } from "react";

/**
 * Image avec repli élégant.
 *
 * Tant que la photo n'existe pas dans `public/img/`, on affiche un aplat
 * dégradé aux couleurs de la marque avec un libellé, au lieu d'une image
 * cassée. Déposez le fichier au chemin indiqué et il s'affiche tout seul.
 */
export const Photo = ({ src, alt, label, className = "", ...rest }) => {
  const [failed, setFailed] = useState(!src);

  if (failed) {
    return (
      <div className={`photo-fallback ${className}`} role="img" aria-label={alt} {...rest}>
        <span>{label || alt}</span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      loading="lazy"
      onError={() => setFailed(true)}
      {...rest}
    />
  );
};

export default Photo;
